var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import makeStyles from "@mui/styles/makeStyles";
export default makeStyles(function (_a) {
    var _b = _a.palette, primary = _b.primary, secondary = _b.secondary, spacing = _a.spacing, typography = _a.typography;
    return ({
        category: {
            backgroundColor: primary.light,
            marginBottom: spacing(0.5),
        },
        hover: {
            "&:hover": {
                backgroundColor: primary.dark,
            },
        },
        logo: __assign(__assign({}, typography.h1), { "&::after": {
                content: '"\u00ae"',
            } }),
        paper: {
            backgroundColor: primary.main,
            width: spacing(32),
        },
        selected: {
            backgroundColor: "".concat(primary.dark, " !important"),
        },
        externalLink: __assign(__assign({ color: secondary.light, textDecoration: "none", display: "block", paddingTop: typography.pxToRem(8), paddingBottom: typography.pxToRem(8), paddingLeft: typography.pxToRem(72) }, typography.h5), { "&:hover": {
                backgroundColor: primary.dark,
            } }),
    });
});
//# sourceMappingURL=useStyles.js.map